import { createActionGroup } from '@ngrx/store';

export const PatrimoineHierarchieTemplateActions = createActionGroup({
  source: 'Patrimoine Hierarchie Template',
  events: {}
});
